import ajax from '../../lib/ajax';

export async function QueryStandingBookDetail(payload:any) {
	//耗材台账明细
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryStandingBookDetail`,payload)
	return res.data.result
}
export async function QueryConStandingBook(payload:any) {
	//查询耗材台账
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryStandingBook`,payload)
	return res.data.result
}
export async function QuerySupplier(payload:any) {
	//查询所有供货商
	let res = await ajax.post(`/api/services/app/Ghscode/QuerySupplier`,payload)
	return res.data.result
}
export async function QueryConsumableBatchNum(payload:any) {
	//获取耗材库存批号信息
	let res = await ajax.get(`/api/services/app/ConManagerment/QueryConsumableBatchNum`,{params:payload})
	return res.data.result
}




export async function CreateStockIn(payload:any) {
	//创建入库单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateStockIn`,payload)
	return res.data.result
}
export async function CreateStockOut(payload:any) {
	//创建出库单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateStockOut`,payload)
	return res.data.result
}
export async function CreateStockBreakage(payload:any) {
	//创建报损单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateStockBreakage`,payload)
	return res.data.result
}
export async function CreateConsumableDiscount(payload:any) {
	//创建调价单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateConsumableDiscount`,payload)
	return res.data.result
}
export async function CreateStockCheck(payload:any) {
	//创建盘点单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateStockCheck`,payload)
	return res.data.result
}
export async function CreateStockRefund(payload:any) {
	//创建退货单(暂存)
	let res = await ajax.post(`/api/services/app/ConManagerment/CreateStockRefund`,payload)
	return res.data.result
}


export async function QueryReceiptConsumableStockIn(payload:any) {
	//查询入库单据
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableStockIn`,payload)
	return res.data.result
}

export async function QueryReceiptConsumableStockOut(payload:any) {
	//查询入库单据
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableStockOut`,payload)
	return res.data.result
}


export async function EditStockInCheck(payload:any) {
	//入库核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockInCheck`,payload)
	return res.data.result
}
export async function EditStockOutCheck(payload:any) {
	//出库核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockOutCheck`,payload)
	return res.data.result
}
export async function EditStockBreakageCheck(payload:any) {
	//报损核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockBreakageCheck`,payload)
	return res.data.result
}
export async function EditStockCheckCheck(payload:any) {
	//盘点核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockCheckCheck`,payload)
	return res.data.result
}
export async function EditStockRefundCheck(payload:any) {
	//退货核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockRefundCheck`,payload)
	return res.data.result
}
export async function EditStockDiscountCheck(payload:any) {
	//调价核对
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockDiscountCheck`,payload)
	return res.data.result
}

export async function EditStockInCharge(payload:any) {
	//入库记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockInCharge`,payload)
	return res.data.result
}
export async function EditStockOutCharge(payload:any) {
	//出库记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockOutCharge`,payload)
	return res.data.result
}
export async function EditStockBreakageCharge(payload:any) {
	//报损记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockBreakageCharge`,payload)
	return res.data.result
}
export async function EditStockCheckCharge(payload:any) {
	//盘点记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockCheckCharge`,payload)
	return res.data.result
}
export async function EditStockRefundCharge(payload:any) {
	//退货记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockRefundCharge`,payload)
	return res.data.result
}
export async function EditStockDiscountCharge(payload:any) {
	//调价记账
	let res = await ajax.post(`/api/services/app/ConManagerment/EditStockDiscountCharge`,payload)
	return res.data.result
}

export async function QueryConStockIn(payload:any) {
	//入库查询单
	let res = await ajax.get(`/api/services/app/ConManagerment/GetConStockIn`,{params:payload})
	return res.data.result
}
export async function QueryConManagermenttorageStockOut(payload:any) {
	//出库查询单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConManagermenttorageStockOut`,payload)
	return res.data.result
}
export async function QueryConManagermenttockBreakage(payload:any) {
	//报损查询单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConManagermenttockBreakage`,payload)
	return res.data.result
}
export async function QueryConsumableCheck(payload:any) {
	//盘点查询单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableCheck`,payload)
	return res.data.result
}
export async function QueryConManagermenttorageStockRefund(payload:any) {
	//退货查询单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConManagermenttorageStockRefund`,payload)
	return res.data.result
}
export async function QueryConManagermenttorageStockDiscount(payload:any) {
	//调价查询单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConManagermenttorageStockDiscount`,payload)
	return res.data.result
}

export async function QueryDepartmentByNameList(payload:any) {
	let res = await ajax.post(`/api/services/app/Utcode/QueryDepartmentByNameList`, payload)
	return res.data.result
}
export async function QueryStockInDetailById(payload:any) {
	//入库查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConStockInDetail`, payload)
	return res.data.result
}
export async function QueryConsumableStockBreakage(payload:any) {
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableStockBreakage`, payload)
	return res.data.result
}
export async function QueryStockOutDetailById(payload:any) {
	//出库查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryStockOutById`,payload)
	return res.data.result
}
export async function QueryStockBreakageDetailById(payload:any) {
	//报损查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryStockBreakageDetailById`,payload)
	return res.data.result
}
export async function QueryConsumableCheckDetailById(payload:any) {
	//盘点查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableCheckDetailById`,payload)
	return res.data.result
}
export async function QueryStockRefundDetailById(payload:any) {
	//退货查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryStockRefundDetailById`,payload)
	return res.data.result
}
export async function QueryStockDiscountDetailById(payload:any) {
	//调价查询单详情
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableDiscountDetailById`,payload)
	return res.data.result
}


export async function DeleteStockIn(payload:any) {
	//删除入库单据
	let res = await ajax.delete(`/api/services/app/ConManagerment/DeleteStockIn`,payload)
	return res.data.result
}
export async function DeleteStockOut(payload:any) {
	//删除出库单据
	let res = await ajax.post(`/api/services/app/ConManagerment/EditDelStockOut`,payload)
	return res.data.result
}
export async function DeleteStockBreakage(payload:any) {
	//删除报损单据
	let res = await ajax.post(`/api/services/app/ConManagerment/EditDelStockBreakage`,payload)
	return res.data.result
}
export async function DeleteStockCheck(payload:any) {
	//删除盘点单据
	let res = await ajax.post(`/api/services/app/ConManagerment/EditDelStockCheck`,payload)
	return res.data.result
}
export async function DeleteStockRefund(payload:any) {
	//删除退货单据
	let res = await ajax.post(`/api/services/app/ConManagerment/EditDelStockRefund`,payload)
	return res.data.result
}
export async function DeleteStockDiscount(payload:any) {
	//删除调价单据
	let res = await ajax.post(`/api/services/app/ConManagerment/EditDelStockDiscount`,payload)
	return res.data.result
}

export async function DeleteStockInDetail(payload:any) {
	//删除入库单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockInDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockOutDetail(payload:any) {
	//删除出库单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockOutDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockBreakageDetail(payload:any) {
	//删除报损单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockBreakageDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockCheckDetail(payload:any) {
	//删除盘点单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockCheckDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockRefundDetail(payload:any) {
	//删除退货单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockRefundDetail`,{params:payload})
	return res.data.result
}
export async function DeleteStockDiscountDetail(payload:any) {
	//删除调价单据明细
	let res = await ajax.post(`/api/services/app/ConManagerment/DeleteStockDiscountDetail`,{params:payload})
	return res.data.result
}


export async function EditConsumableRedDashed(payload:any) {
	//红冲
	let res = await ajax.post(`/api/services/app/ConManagerment/EditConsumableRedDashed`,payload)
	return res.data.result
}
export async function QueryReceiptConManagermenttockIn(payload:any) {
	//查询入库单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConManagermenttockIn`,payload)
	return res.data.result
}
export async function QueryReceiptConManagermenttockOut(payload:any) {
	//查询出库单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConManagermenttockOut`,payload)
	return res.data.result
}
export async function QueryReceiptConsumableBreakage(payload:any) {
	//查询报损单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableBreakage`,payload)
	return res.data.result
}
export async function QueryReceiptConsumableCheck(payload:any) {
	//查询盘点单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableCheck`,payload)
	return res.data.result
}
export async function QueryReceiptConsumableRefund(payload:any) {
	//查询退货单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableRefund`,payload)
	return res.data.result
}
export async function QueryReceiptConsumableDiscount(payload:any) {
	//查询调价单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryReceiptConsumableDiscount`,payload)
	return res.data.result
}


export async function QuryConsumableWarning(payload:any) {
	//耗材有效期预警
	let res = await ajax.post(`/api/services/app/ConManagerment/QuryConsumableWarning`,payload)
	return res.data.result
}
export async function QueryConManagermenttockWarning(payload:any) {
	//耗材库存预警
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConManagermenttockWarning`,payload)
	return res.data.result
}
export async function QueryConsumableStorageStockRefund(payload:any) {
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableStorageStockRefund`,payload)
	return res.data.result
}

export async function QueryConsumableStockWarning(payload:any) {
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableStockWarning`,payload)
	return res.data.result
}
export async function QueryConsumableStorageStockDiscount(payload:any) {
	// 查询调价单
	let res = await ajax.post(`/api/services/app/ConManagerment/QueryConsumableStorageStockDiscount`,payload)
	return res.data.result
}

export async function QueryConsumableStorageStockOut(payload:any) {
	//耗材库存预警
	let res = await ajax.get(`/api/services/app/ConManagerment/QueryConsumableStorageStockOut`,{params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/consumablesStock/index.ts